
import { createAction } from 'redux-actions'
import request from 'superagent'
import moment from 'moment'
import fetch from 'lib/fetch'
import { getMTUsForPast30Days, getMTUsBySourceForCurrentPeriod } from 'selectors'

export const REQUEST_MTUS_FOR_PAST_30_DAYS = 'REQUEST_MTUS_FOR_PAST_30_DAYS'
export const REQUEST_MTUS_FOR_PAST_30_DAYS_ERROR = 'REQUEST_MTUS_FOR_PAST_30_DAYS_ERROR'
export const RECEIVE_MTUS_FOR_PAST_30_DAYS = 'RECEIVE_MTUS_FOR_PAST_30_DAYS'
export const REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS = 'REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS'
export const REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS_ERROR = 'REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS_ERROR'
export const RECEIVE_BILLING_COUNTS_FOR_PAST_6_MONTHS = 'RECEIVE_BILLING_COUNTS_FOR_PAST_6_MONTHS'
export const REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS = 'REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS'
export const REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS_ERROR = 'REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS_ERROR'
export const RECEIVE_BILLING_COUNTS_FOR_PAST_X_MONTHS = 'RECEIVE_BILLING_COUNTS_FOR_PAST_X_MONTHS'
export const REQUEST_MTUS_FOR_CURRENT_PERIOD = 'REQUEST_MTUS_FOR_CURRENT_PERIOD'
export const REQUEST_MTUS_FOR_CURRENT_PERIOD_ERROR = 'REQUEST_MTUS_FOR_CURRENT_PERIOD_ERROR'
export const RECEIVE_MTUS_FOR_CURRENT_PERIOD = 'RECEIVE_MTUS_FOR_CURRENT_PERIOD'

const requestBillingCountsForPast6Months = createAction(REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS)
const requestBillingCountsForPast6MonthsError = createAction(REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS_ERROR)
const receiveBillingCountsForPast6Months = createAction(RECEIVE_BILLING_COUNTS_FOR_PAST_6_MONTHS)
const requestBillingCountsForPastXMonths = createAction(REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS)
const requestBillingCountsForPastXMonthsError = createAction(REQUEST_BILLING_COUNTS_FOR_PAST_X_MONTHS_ERROR)
const receiveBillingCountsForPastXMonths = createAction(RECEIVE_BILLING_COUNTS_FOR_PAST_X_MONTHS)
const requestMTUsForCurrentPeriod = createAction(REQUEST_MTUS_FOR_CURRENT_PERIOD)
const requestMTUsForCurrentPeriodError = createAction(REQUEST_MTUS_FOR_CURRENT_PERIOD_ERROR)
const receiveMTUsForCurrentPeriod = createAction(RECEIVE_MTUS_FOR_CURRENT_PERIOD)

export function fetchMTUsForPast30Days (slug) {
  return {
    types: {
      request: REQUEST_MTUS_FOR_PAST_30_DAYS,
      receive: RECEIVE_MTUS_FOR_PAST_30_DAYS,
      failure: REQUEST_MTUS_FOR_PAST_30_DAYS_ERROR
    },
    shouldCallAPI: state => {
      const mtus = getMTUsForPast30Days(state, slug) || {}
      return !mtus.data && !mtus.isRequesting
    },
    callAPI: () => fetch(`/api/workspaces/${slug}/billing/counts?days=30`).then(res => {
      if (!res.ok) {
        const err = new Error(`Failed to fetch the past 30 days of MTUs for ${slug} (${res.status})`)
        err.status = res.status
        throw err
      }
      return res.json()
    }),
    payload: { slug }
  }
}

export const REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD = 'REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD'
export const RECEIVE_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD = 'RECEIVE_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD'
export const REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD_ERROR = 'REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD_ERROR'

export function fetchMTUsBySourceForCurrentPeriod (workspaceSlug, force = false) {
  return {
    types: {
      request: REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD,
      receive: RECEIVE_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD,
      failure: REQUEST_MTUS_BY_SOURCE_FOR_CURRENT_PERIOD_ERROR
    },
    shouldCallAPI: state => {
      if (force) return true
      const mtus = getMTUsBySourceForCurrentPeriod(state, workspaceSlug) || {}
      return !mtus.data && !mtus.isRequesting
    },
    callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/billing/source-counts?period=${(new Date()).toISOString()}`).then(res => {
      if (!res.ok) {
        const err = new Error('Unable to fetch source MTUs')
        err.state = res.status
        throw err
      }
      return res.json()
    }),
    payload: { workspaceSlug }
  }
}

const fetchBillingCountsForPeriod = (workspaceSlug, period) => {
  return new Promise(function (resolve, reject) {
    request
    .get(`/api/workspaces/${workspaceSlug}/billing/counts`)
    .query({ period })
    .end(function (err, res) {
      if (err || !res.ok) {
        reject(new Error(`Unable to fetch billing information for period ${moment(period).format('MMM')}`))
      } else {
        resolve(res.body)
      }
    })
  })
}

function monthsAgo (n) {
  return moment(new Date()).subtract(n, 'months')
}

export const fetchBillingCountsForPastXMonths = (workspaceSlug, months = 6, actionOverride = {}) => dispatch => {
  const promises = []
  // grab the previous X months' MTUs
  for (let i = 1; i <= months; i++) {
    promises.push(fetchBillingCountsForPeriod(workspaceSlug, monthsAgo(i)))
  }

  const {
    requestBillingCounts = requestBillingCountsForPastXMonths,
    receiveBillingCounts = receiveBillingCountsForPastXMonths,
    errorBillingCounts = requestBillingCountsForPastXMonthsError
  } = actionOverride

  dispatch(requestBillingCounts({ workspaceSlug, monthsAgo: months }))

  return Promise.all(promises)
  .then(function ([ ...data ]) {
    dispatch(receiveBillingCounts({ workspaceSlug, monthsAgo: months, data }))
  })
  .catch(function (error) {
    dispatch(errorBillingCounts({ workspaceSlug, monthsAgo: months, error }))
  })
}

export const fetchBillingCountsForPast6Months = workspaceSlug => {
  const actionOverride = {
    requestBillingCounts: requestBillingCountsForPast6Months,
    receiveBillingCounts: receiveBillingCountsForPast6Months,
    errorBillingCounts: requestBillingCountsForPast6MonthsError
  }
  return fetchBillingCountsForPastXMonths(workspaceSlug, 6, actionOverride)
}

export const fetchMTUsForCurrentPeriod = workspaceSlug => dispatch => {
  dispatch(requestMTUsForCurrentPeriod({ workspaceSlug }))

  return fetchBillingCountsForPeriod(workspaceSlug, new Date().toISOString())
  .then(function (data) {
    dispatch(receiveMTUsForCurrentPeriod({ workspaceSlug, data }))
  })
  .catch(function (error) {
    dispatch(requestMTUsForCurrentPeriodError({ workspaceSlug, error }))
  })
}



// WEBPACK FOOTER //
// ./actions/mtus.js